<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import api from '@/helpers/api'
import CustomViews from './custom-views'
import ShippingCard from './shared/shipping-card.vue'
import customViews from './custom-views'
import { vue3dLoader } from 'vue-3d-loader'
/**
 * Dashboard Component
 */
export default {
  name: 'sales.web-orders.view',
  page: {
    title: 'My Orders - View',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    ShippingCard,
    vue3dLoader
  },
  props: {
    orderId: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    fileUrl: '',
    isFileLoading: true,
    showStl: false,
    fileLoadProgress: 0,
    lights: [
      {
        type: 'point',
        color: '#0095f5',
        intensity: 1
      }
    ],
    webForm: {
      item: {},
      user: {},
      customer: {}
    }
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    orderId: 'onInit'
  },

  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.webForms.fetch({
        id: this.orderId
      })
      this.webForm = {
        ...item
      }
      this.fileUrl = await this.getFileUrl(item.file_id)
      this.isLoading = false
    },
    async downloadFile (id) {
      this.isLoading = true

      let url = await this.getFileUrl(id)
      window.open(url, '_blank', 'noreferrer')
      this.isLoading = false
    },
    print () {
      window.print()
    },
    async getFileUrl (id) {
      if (!id) return null
      let { url } = await api.files.download_url({
        file_id: id
      })

      return url
    },
    onProcess (event, index) {
      this.fileLoadProgress = Math.floor((event.loaded / event.total) * 100)

      if (this.fileLoadProgress < 100) this.isFileLoading = true
      else this.isFileLoading = false
    }
  },
  computed: {
    title () {
      return 'My Order'
    },
    customView () {
      let { type } = this.webForm

      let comp = null
      if (CustomViews.hasOwnProperty(type) && CustomViews[type].component)
        comp = CustomViews[type].component

      return comp
    },
    breadcrumbs () {
      return [
        {
          text: 'My Orders',
          to: { name: 'sales.my-orders' }
        },
        {
          text: this.webForm.item
            ? `${this.webForm.item.short_description}`
            : 'loading',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :items="breadcrumbs"
      :title="$t('order details')"
      class="d-print-none"
    >
      <template v-slot:title
        ><h4 class="mb-0">
          order details
          <b-btn
            variant="link"
            size="lg"
            class="text-uppercase d-print-none"
            :title="$t('Print')"
            v-on:click="print"
          >
            <i class="bx bx-printer mr-1" />
          </b-btn>
        </h4>
      </template>
    </PageHeader>

    <b-row>
      <b-col :cols="9" :sm="12" :md="8">
        <b-card no-body>
          <b-card-body>
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <i class="fab fa-wpforms font-size-24 mr-4" />
                <div
                  class="justify-content-start align-items-center"
                  :title="webForm.item.extra_description"
                  v-b-tooltip.right.hover
                >
                  <h6 class="text-truncate m-0">
                    {{ webForm.item.short_description }}
                  </h6>
                  <span class="small text-muted pt-0 m-0">
                    {{ webForm.item.code }}
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-end">
                <app-status-badge :status="webForm.status" />
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <div>
                <h6 class="mt-4">{{ $t('reference') }}</h6>
                <p class="p-0 m-0 text-muted">{{ webForm.reference }}</p>
              </div>
              <div class="mx-3 text-center">
                <h6 class="mt-4">{{ $t('quantity') }}</h6>
                <p class="p-0 m-0 text-muted">
                  {{ webForm.quantity }}
                </p>
              </div>
            </div>

            <b-row no-gutters>
              <b-col :cols="12" v-if="!!webForm.file">
                <h6 class="mt-4">{{ $t('file') }}</h6>
                <b-btn
                  variant="link"
                  v-on:click="downloadFile(webForm.file.id)"
                >
                  <i class="mdi mdi-file-check-outline"></i>
                  {{ webForm.file.file_name }}
                  <span class="small mx-1"
                    >({{ webForm.file.file_size | prettyBytes }})</span
                  >
                  <i class="mdi mdi-download ml-2"></i
                ></b-btn>
              </b-col>

              <b-col :cols="12" class="my-2" v-if="!!webForm.file">
                <vue3dLoader
                  :parallelLoad="true"
                  :filePath="fileUrl"
                  fileType="stl"
                  :enableAxesHelper="true"
                  :axesHelperSize="500"
                  :enableDamping="true"
                  :dampingFactor="0.05"
                  :height="300"
                  :controlsOptions="{
                    enablePan: false,
                    enableZoom: false
                  }"
                  :pointLightFollowCamera="true"
                  :lights="lights"
                  @process="onProcess"
                  backgroundColor="#FFF"
                  class="p-0 m-0"
                /><b-progress
                  v-show="fileLoadProgress < 100"
                  :value="fileLoadProgress"
                  height="2px"
                ></b-progress>
              </b-col>

              <b-col :cols="12">
                <component
                  :is="customView"
                  v-model="webForm.form_data"
                  v-if="!!customView"
                />
                <app-default-specs
                  :specs="webForm.form_data"
                  v-else
                ></app-default-specs>
              </b-col>

              <b-col :cols="12" v-if="!!webForm.comments">
                <h6 class="mt-4">{{ $t('comments') }}</h6>
                <p class="p-0 m-0 text-muted">{{ webForm.comments }}</p>
              </b-col>

              <b-col
                :cols="12"
                v-if="
                  !!webForm.web_form_files && webForm.web_form_files.length > 0
                "
              >
                <h6 class="mt-4">{{ $t('aditional files') }}</h6>
                <b-row>
                  <b-col
                    v-for="wff in webForm.web_form_files"
                    :key="wff.file.id"
                    class="pb-1 px-0"
                    :cols="12"
                  >
                    <b-btn
                      variant="link"
                      v-on:click="downloadFile(wff.file.id)"
                    >
                      <i
                        v-if="wff.file.file_content_type === 'application/pdf'"
                        class="mdi mdi-file-pdf-outline"
                      ></i>
                      <i v-else class="mdi mdi-file-image-outline"></i>
                      {{ wff.file.file_name }}
                      <span class="small mx-1"
                        >({{ wff.file.file_size | prettyBytes }})</span
                      >
                      <i class="mdi mdi-download ml-2"></i
                    ></b-btn>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col :cols="3" :sm="12" :md="4">
        <b-card no-body>
          <b-card-body>
            <b-row no-gutters align-v="start" align-h="start" class="mb-4">
              <i class="far fa-user font-size-16 mr-4" />
              <div>
                <h6 class="text-truncate mb-1">
                  {{ $t('User') }}
                </h6>
                <p class="text-truncate m-0">
                  {{ webForm.user.name }}
                </p>
                <p class="small text-truncate m-0">
                  {{ webForm.customer.company_name }}
                </p>
              </div>
            </b-row>
            <b-row no-gutters align-v="start" align-h="start" class="mb-4">
              <i class="far fa-clock font-size-16 mr-4" />
              <div>
                <h6 class="text-truncate mb-1">
                  {{ $t('Submitted') }}
                </h6>
                <p class="text-truncate m-0">
                  {{ webForm.submitted_at | moment('ddd D MMM YYYY ') }}
                </p>
              </div>
            </b-row>
            <b-row no-gutters align-v="start" align-h="start" class="mb-0">
              <i class="far fa-clock font-size-16 mr-4" />
              <div>
                <h6 class="text-truncate mb-1">
                  {{ $t('Last Updated') }}
                </h6>
                <p class="text-truncate m-0">
                  {{ webForm.updated_at | moment('ddd D MMM YYYY - hh:mm') }}
                </p>
              </div>
            </b-row>
          </b-card-body>
        </b-card>
        <shipping-card :shipping-address="webForm.shipping_address" />
      </b-col>
    </b-row>
    <b-row no-gutters v-if="false">
      <b-card no-body
        ><b-card-body><g-pretty-print :value="webForm.form_data" /></b-card-body
      ></b-card>
    </b-row>
    <!-- end row -->
  </Layout>
</template>
